import axios from 'axios/index'

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

export default {
  getQuestions () {
    return http.get('/questions').then(resp => resp.data)
  },
  getAnimals () {
    return http.get('/animals').then(resp => resp.data)
  },
  getHideAndSeek () {
    return http.get('/hide-and-seek').then(resp => resp.data)
  },
  getFacts () {
    return http.get('/facts').then(resp => resp.data)
  },
  getAvatars () {
    return http.get('/avatars').then(resp => resp.data)
  },
  getAvatarShoes () {
    return http.get('/avatar_shoes').then(resp => resp.data)
  },
  getFactCards () {
    return http.get('/factcards').then(resp => resp.data)
  },
  getFactFiles () {
    return http.get('/factfiles').then(resp => resp.data)
  },
  registerUser (data) {
    return http.post('/register_user', data, { headers: { 'Content-Type': 'application/json' } }).then(resp => resp.data)
  },
  setS (data) {
    return http.post('/s', data, { headers: { 'Content-Type': 'application/json' } }).then(resp => resp.data)
  },
  getLeaderBoard () {
    return http.get('/leaderboard').then(resp => resp.data)
  }
}
